export default __webpack_public_path__ + "static/media/Kontakty pro hlášení poruch.dac8b4e4.pdf";